exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".collection-header{border-bottom:3px solid #e5dada;padding-bottom:23px}.parent-title{color:#7a7a7a}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./~/postcss-loader!./src/pages/CollectionPage.scss
// module id = 746
// module chunks = 0